import { SearchForm } from '@/components/views/SearchForm'

import { FILTER_VEHICLE_TYPES_CARS } from '../../../lib/constants'
import styles from './search-form-cta.module.scss'

export const SearchFormCTA = () => {
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <h2 className={styles.title}>Quickly search all the big leasing sites</h2>
        <SearchForm initialVehicleType={FILTER_VEHICLE_TYPES_CARS} />
      </div>
    </div>
  )
}
